export const Frequency = [
  { label: 'daily', value: 'Daily'},
  { label: 'monthly', value: 'Monthly'}
];

export const Days = [
  { label: 'monday', value: 'Monday'},
  { label: 'tuesday', value: 'Tuesday'},
  { label: 'wednesday', value: 'Wednesday'},
  { label: 'thursday', value: 'Thursday'},
  { label: 'friday', value: 'Friday'},
  { label: 'saturday', value: 'Saturday'},
  { label: 'sunday', value: 'Sunday'}
];

export const Months = [
  { label: 'january' , value: 'January'},
  { label: 'february' , value: 'February'},
  { label: 'march' , value: 'March'},
  { label: 'april' , value: 'April'},
  { label: 'may' , value: 'May'},
  { label: 'june' , value: 'June'},
  { label: 'july' , value: 'July'},
  { label: 'august' , value: 'August'},
  { label: 'september' , value: 'September'},
  { label: 'october' , value: 'October'},
  { label: 'november' , value: 'November'},
  { label: 'december' , value: 'December'}
];

export const AllDays = () => {
  let limit = 1;
  let days = [];

  while (limit <= 31) {
    days.push({ key: `${limit}`, text: `${limit}`, value: `${limit}`});
    limit++;
  }
  return days;
};